
$(window).on('load', () => {
	(() => {
	  $(document).ready(() => {
		$(document).on("swell:initialized", () => {
			console.log("swell:initialized");
			 new RedemptionDiscount(spapi.activeRedemptionOptions).renderRedemptionList();
				 new CampaignGrid(swellAPI.getActiveCampaigns()).renderCampaignGrid();
				 new RedemptionProduct(spapi.activeRedemptionOptions,swellDefenitions.rewardsRedemptionPrudoct).renderProductList();


		});
		$(document).on("swell:setup", () => {
			console.log("swell:setup");
         new CampaignGrid(swellAPI.getActiveCampaigns()).renderCampaignBakcgroundCssHover(swellAPI.getCustomerDetails());
         new RedemptionDiscount(swellAPI.getActiveCampaigns()).renderRedemptionDiscountBakcgroundCssHover(swellAPI.getCustomerDetails());
			    new VIPTiers(
			   	//swellDefenitions.baseVIPTier,
			   	swellAPI.getVipTiers(),
			   	swellDefenitions.vipTiersSetting,
			   	swellAPI.getCustomerDetails()
			   	 ).renderVIPTiers();
			     new RedemptionProduct(spapi.activeRedemptionOptions,swellDefenitions.rewardsRedemptionPrudoct).renderProductRedemptionsPopup(swellAPI.getCustomerDetails());

			   
		});
	  });
	}).call(this);
})